










import { defineComponent } from 'vue';
import AulaAlert from '../../../shared/components/AulaAlert.vue';
import { useSearchAlert } from '../../composables/global_search/useSearchAlert';

export default defineComponent({
  name: 'GlobalSearchAlert',
  components: { AulaAlert },
  setup() {
    const { isVisible, handleAlertClick } = useSearchAlert();
    return { isVisible, handleAlertClick };
  },
});
